import React, { useRef, useEffect } from "react";
import { Form, message } from "antd";
import { YHDrawer } from "@/components/YhDrawer";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { YhForm } from "@/components/YhFormBox";
import { getFormValidatorErrText, momentFormat } from "@/utils/utils";
import { usePurchaseApprovalModel } from "../purchaseApprovalModel";
import useGlobalModel, { transOptions } from "@/model/globalModel";
import { purchaseApprovalService } from "../purchaseApprovalService";
import { getBaseImgLookUrl } from "@/utils/constants";
import { Image } from 'antd';
//结算
export function LogDrawer() {
    // 新增审批状态类型定义

    // 审批节点状态样式映射
    const statusStyles: any = {
        2: { color: '#52C41A', bgColor: '#52C41A', borderColor: 'rgba(82, 196, 26, 0.24)' },//审批通过
        8: { color: '#d82007', bgColor: '#F5222D', borderColor: 'rgba(245, 34, 45, 0.25)' },//审批驳回
        0: { color: '#FF9900', bgColor: '#FFC53D', borderColor: 'rgba(255, 197, 61, 0.3)' },//待处理
    };
    const { logVisible: visible, setLogVisible, selectedRowKeys, } = usePurchaseApprovalModel();
    // 进度节点配置
    const getProgressNodes = (data: any) => {
        // 外修进度节点
        if (data.enquiry) {
            return [
                {
                    status: '已开单',
                    key: 'create',
                    timeField: momentFormat(data.createTime) ?? '',
                    userField: data.createUser
                },
                {
                    status: '提报',
                    key: 'wait',
                    timeField: momentFormat(data.fillingTime) ?? '',
                    userField: data.informant
                },
                {
                    status: '审批(审批单)',
                    key: 'repairing',
                    timeField: momentFormat(data.approvalTime) ?? '',
                    userField: data.approver,
                    approvalStatus: (data.approvalTime && data.status == 'purchase_approval.reject') ? '审批驳回' : (data.approvalTime && data.status !== 'purchase_approval.reject') ? '审批通过' : '未审核'
                },
                {
                    status: '发布',
                    key: 'completed',
                    timeField: momentFormat(data.enquiry.sendTime) ?? '',
                    userField: data.enquiry.sendUser
                },
                {
                    status: '询价完成',
                    key: 'completed',
                    timeField: momentFormat(data.enquiry.sendTime) ?? '',
                    userField: data.enquiry.sendUser
                },
                {
                    status: '审批(询价单)',
                    key: 'completed',
                    timeField: momentFormat(data.enquiry.approvalTime) ?? '',
                    userField: data.enquiry.approver,
                    approvalStatus: (data.enquiry.approvalTime && data.enquiry.status == 'purchase_enquiry.reject') ? '审批驳回' : (data.enquiry.approvalTime && data.enquiry.status !== 'purchase_enquiry.reject') ? '审批通过' : '未审核'
                },
                {
                    status: '转订单',
                    key: 'completed',
                    timeField: momentFormat(data.transferTime) ?? '',
                    userField: data.transferUser
                }
            ];
        }
        // 内修进度节点
        return [
            {
                status: '已开单',
                key: 'create',
                timeField: momentFormat(data.createTime),
                userField: data.createUser
            },
            {
                status: '提报',
                key: 'wait',
                timeField: momentFormat(data.fillingTime),
                userField: data.informant
            },
            {
                status: '审批(审批单)',
                key: 'repairing',
                timeField: momentFormat(data.approvalTime),
                userField: data.approver,
                approvalStatus: (data.approvalTime && data.status == 'purchase_approval.reject') ? '审批驳回' : (data.approvalTime && data.status !== 'purchase_approval.reject') ? '审批通过' : '未审核'
            },
            {
                status: '转订单',
                key: 'completed',
                timeField: momentFormat(data.transferTime),
                userField: data.transferUser
            }
        ];
    };
    // 新增：存储从服务器获取的详情数据
    const [detailData, setDetailData] = React.useState<any>({});
    // 新增：加载状态
    const [loading, setLoading] = React.useState(false);

    // 进入页面单条查询，获取数据填入
    useEffect(() => {
        if (visible && selectedRowKeys[0]) {
            fetchDetail(selectedRowKeys[0]);
        }
    }, [visible, selectedRowKeys[0]]);

    // 新增：获取详情数据的函数
    const fetchDetail = async (id: string) => {
        setLoading(true);
        const res = await purchaseApprovalService.oneLog(id);
        setDetailData({
            ...res.retData,
        })
        setLoading(false)
    }

    // 获取进度列表
    const getProgressList = () => {
        const nodes = getProgressNodes(detailData);

        return nodes.map((node) => {
            const time = node.timeField ? node.timeField : '';
            const user = node.userField || '未知';
            // 判断节点是否激活（有时间即表示已完成）
            const active = !!node.timeField;
            const approvalType = node.approvalStatus;
            return { ...node, time, user, active, approvalType };
        });
    };
    const progressList = getProgressList();
    const onCancel = () => {
        setLogVisible(false);
    }
    const onOk = () => {
        setLogVisible(false);
    }
    const onFinish = (val: any) => {

    }

    // 带标题的图片预览组件
    const ImagePreview: React.FC<{ url?: any; title: string }> = ({ url, title }) => {
        return (
            <div style={{ width: 'calc(50% - 16px)', boxSizing: 'border-box' }}>
                <Image
                    src={getBaseImgLookUrl(url)}
                    style={{ width: '180px', height: '140px', borderRadius: 4, border: '1px solid #e8e8e8' }}
                />
                <div style={{ textAlign: 'center', marginTop: 4, fontSize: 12, color: '#666' }}>
                    {title}
                </div>
            </div>
        );
    };



    // 生成的审批节点
    const approvalNodes: any = detailData ? detailData.availNode : [];

    return (
        <YHDrawer
            {...{
                title: '流转记录',
                visible,
                cancelText: "返回",
                onCancel,
                width: 600,
                loading,
                onOk
            }}
        >
            {/* <YhForm {...formConfig} /> */}
            {/* 审批进度组件 */}
            <div style={{ marginTop: 24, padding: '0 24px' }}>


                <div style={{ position: 'relative', paddingLeft: '24px' }}>
                    {progressList.map((item, index) => (
                        <div key={item.key} style={{ position: 'relative', marginBottom: '24px' }}>
                            {/* 节点 */}
                            <div style={{
                                position: 'absolute',
                                left: '-24px',
                                top: '0',
                                width: '16px',
                                height: '16px',
                                borderRadius: '50%',
                                backgroundColor: item.active ? '#00BE87' : '#ccc'
                            }}></div>

                            {/* 内容 */}
                            <div>
                                <div style={{ fontSize: '18px', color: '#333', fontWeight: 'bold', marginBottom: '4px' }}>
                                    {item.status}
                                </div>
                                <div style={{ fontSize: '16px', color: '#666', marginBottom: '2px' }}>
                                    操作人：{item.user}
                                </div>
                                <div style={{ fontSize: '16px', color: '#999' }}>
                                    时间：{item.time || '未完成'}
                                </div>
                                {item.approvalType && <div style={{
                                    fontSize: '16px', color: item.approvalType == '审批通过' ? '#00BE87' : item.approvalType == '审批驳回' ? '#d82007' : '#999'
                                }}>
                                    审批状态：{item.approvalType}
                                </div>}
                            </div>

                            {/* 连接线（最后一个节点没有） */}
                            {index !== progressList.length - 1 && (
                                <div style={{
                                    position: 'absolute',
                                    left: '-16px',
                                    top: '16px',
                                    width: '2px',
                                    height: 'calc(100% + 8px)',
                                    backgroundColor: '#eee'
                                }}></div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </YHDrawer >
    )
}    